import './AboutPage.css';

export default function AboutPage() {
  return (
    <main className="about-page">

      <div className="about-hero">
        <div className="about-hero-inner">
          <div className="section-label">About Us</div>
          <h1>Built from lived experience.</h1>
          <p className="about-lead">
            Trenda exists because one developer with forty years of type 1 diabetes
            decided to build the tool they'd always wanted.
          </p>
        </div>
      </div>

      <div className="about-body">
        <div className="about-content">

          <div className="about-quote">
            <blockquote>
              "I never found a tool that truly matched how I think about diabetes in my real,
              messy, everyday life."
            </blockquote>
          </div>

          <div className="about-paragraphs">
            <p>
              For over forty years I've lived with type 1 diabetes, through finger-prick meters,
              paper logbooks, metal syringes, CGMs that take 2 minutes to return a result, and
              more recently a revolving door of apps and gadgets. In all that time, I never found
              a tool that truly matched how I think about diabetes in my real, messy, everyday
              life. Most apps track numbers, but they rarely capture the full picture: how food,
              movement, sleep, stress, and routine all interact with glucose, and how diabetes
              quietly shapes every one of those choices.
            </p>

            <p>
              My career has been spent as a developer, architect, CTO, and founder, building
              products and systems for other people. I've been fortunate enough to have the
              skills and experience to design complex software, and the lived experience of
              managing diabetes every day. This app is where those two worlds meet. It's not a
              clinical tool or a replacement for medical advice; it's the product I've always
              wanted for myself — simple, intuitive, and focused on making it easier to
              understand the impact of life on diabetes, and diabetes on life.
            </p>

            <p>
              The "team" behind the app starts with that personal journey: a person with decades
              of diabetes experience who finally decided to build the tool they wanted to use.
              As the product grows, it will continue to be shaped by people living with
              diabetes, informed by real-world use, and guided by a single promise: to stay
              practical, respectful, and genuinely useful in day-to-day life.
            </p>
          </div>

          <div className="about-values">
            <div className="value-card">
              <span className="value-icon" aria-hidden="true">🩸</span>
              <h3>Lived experience first</h3>
              <p>Every design decision starts with the question: does this make daily diabetes management genuinely easier?</p>
            </div>
            <div className="value-card">
              <span className="value-icon" aria-hidden="true">🔒</span>
              <h3>Private by design</h3>
              <p>Your health data stays on your device. We don't sell it, share it, or use it for anything beyond running the app.</p>
            </div>
            <div className="value-card">
              <span className="value-icon" aria-hidden="true">🛠️</span>
              <h3>Honest and practical</h3>
              <p>No overpromising. Trenda is a tool to help you understand patterns — not a medical device or a cure.</p>
            </div>
          </div>


        </div>
      </div>

    </main>
  );
}
